module.exports = __webpack_public_path__ + "static/media/vid1.3b0660cd.mp4";